export enum LineHeightEnum {
  // heading
  H1 = '4.2rem',
  H2 = '3.6rem',
  H3 = '3.4rem',
  H4 = '3.1rem',
  H5 = '2.8rem',
  H6 = '2.5rem',

  // body
  Body1 = '2.2rem',
  Body2 = '2.1rem',
  Body3 = '2rem',
  Body4 = '1.8rem',
  Body5 = '1.7rem',

  // caption
  Caption1 = '1.5rem',
  Caption2 = '1.4rem',
}
